<template>

  <body class="dx-viewport">
    <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="dsCampaniiMarketing"
      :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50"
      :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
      :filter-sync-enabled="true" :show-column-lines="false" @selection-changed="onSelectionChanged"
      @row-removing="onRowRemoving" class="border">
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="5" :page-index="1" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxSorting mode="multiple" />
      <DxStateStoring :enabled="true" :filterValue="false" storage-key="CampaniiMarketing" />
      <DxToolbar>
        <DxItem>
          <template #default>
            <DxButton icon="add" type="success" @click="onAddClick" />
          </template>
        </DxItem>
        <DxItem>
          <template #default>
            <DxButton icon="refresh" @click="onRefreshClick" />
          </template>
        </DxItem>
      </DxToolbar>

      <!-- Editare -->
      <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="600" :height="450">
          <DxToolbarItem :template="customTitleTemplate" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid>
          <DxItem :col-span="2" :col-count="2" item-type="group">
            <DxItem data-field="Denumire" :editor-options="{ width: 250 }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>

            <DxItem dataField="IndustrieID" :colSpan="1" :isRequired="false" :editorType="'dxSelectBox'" :editorOptions="{
              dataSource: industrii,
              displayExpr: 'Nume',
              valueExpr: 'ID',
              width: 250
            }" :label="{ text: 'Industrie' }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>


            <DxItem data-field="DataStart" caption="Ziua de început" :isRequired="true" editorType="dxDateBox"
              :editor-options="{ width: 250, displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem data-field="DataEnd" caption="Ziua de final" :isRequired="true" editorType="dxDateBox"
              :editor-options="{ width: 250, displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem data-field="Buget" :isRequired="true" :editor-options="{ width: 250 }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem data-field="CurentActiv" :editor-options="{ width: 250 }" />

            <DxItem data-field="Explicatie" caption="Explicație" :colSpan="2"
              :editor-options="{ width: 555, height: 70 }" />

          </DxItem>
        </DxFormGrid>
      </DxEditing>

      <DxColumn data-field="Denumire" />
      <DxColumn data-field="IndustrieNume" caption="Nume Industrie" />
      <DxColumn data-field="DataStart" caption="Ziua de început" />
      <DxColumn data-field="DataEnd" caption=" Ziua de final" />
      <DxColumn data-field="Buget" />
      <DxColumn data-field="CurentActiv" />
      <DxColumn data-field="Explicatie" caption="Explicație" />
      <DxColumn data-field="UserCreat" :visible="false" />
      <DxColumn data-field="DataCreat" :visible="false" />
      <DxColumn data-field="UserModificat" :visible="false" />
      <DxColumn data-field="DataModificat" :visible="false" />
      <DxColumn data-field="IndustrieID" caption="Industrie" :visible="false" />
    </DxDataGrid>
    <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
      :width="600" :height="450">
      <template #title>
        <div
          style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
          Adăugare
        </div>
      </template>
      <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="addSaveButtonOptions" />
      <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="addCancelButtonOptions" />
      <div>
        <DxForm :formData="formData">
          <DxItem :col-span="2" :col-count="2" item-type="group">
            <DxItem dataField="Denumire" :isRequired="true" :editor-options="{ width: 250 }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem dataField="IndustrieID" :colSpan="1" :isRequired="true" :editorType="'dxSelectBox'" :editorOptions="{
              dataSource: industrii,
              displayExpr: 'Nume',
              valueExpr: 'ID',
              width: 250
            }" :label="{ text: 'Industrie' }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>

            <DxItem dataField="DataStart" :label="{ text: 'Ziua de început' }" :isRequired="true" editorType="dxDateBox"
              :editor-options="{ width: 250, displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }" />
            <DxItem dataField="DataEnd" :label="{ text: 'Ziua de final' }" :isRequired="true" editorType="dxDateBox"
              :editor-options="{ width: 250, displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }" />
            <DxItem dataField="Buget" :isRequired="true" :editor-options="{ width: 250 }" />
            <DxItem dataField="CurentActiv" editorType="dxCheckBox" :editor-options="{ width: 250 }" />

          </DxItem>
          <DxItem dataField="Explicatie" :label="{ text: 'Explicație' }" :colSpan="2"
            :editor-options="{ width: 555, height: 70 }" />

        </DxForm>
      </div>
    </DxPopupAdd>
  </body>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem as DxItemForm,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import CrmCampaniiMarketing from '@/services/Comercial/CrmCampaniiMarketing';
import http from "@/settings/apiSettings";
import GridIndustrii from './GridIndustrii.vue';

export default defineComponent({
  components: {
    DxToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxItem,
    DxPopup,
    DxForm,
    DxLabel,
    DxEditing,
    DxPopupAdd,
    DxToolbarItem,
    DxItemForm,
    DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
  },

  data() {
    return {
      dsCampaniiMarketing: {} as ODataStore,
      industrii: [] as any[],
      isModalVisible: false,
      formData: {
        Denumire: '',
        IndustrieID: '',
        DataStart: null,
        DataEnd: null,
        Buget: '',
        CurentActiv: false,
        Explicatie: '',


      },
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",

      dataGridRef: ref<DxDataGrid | null>(null),
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancelEdit();
        },
      },
      addSaveButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSave();
        },
      },
      addCancelButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancel();
        },
      },
      customTitleTemplate() {
        return `
        <div style="background-color: #ff2c21; font-size: 15px; float: right; height:47px; width:665px; color: white; 
        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
          Editare
        </div>
      `;
      },
    };
  },
  methods: {
    createODataContext() {
      this.dsCampaniiMarketing = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareCampaniiMarketing',
        key: 'ID',
        version: 4,
        beforeSend: (e) => {
          e.headers = {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
          };
        },
      });
    },
    async getIndustrii() {
      try {
        const response = await http.clientComercialOdata.get('/CRM_Industrii?$select=ID,Nume');
        this.industrii = response.data.value;
      } catch (e) {
        console.error("Error fetching industrii:", e);
      }
    },

    onSelectionChanged(e: any) {
      const selectedRow = e.selectedRowsData[0];
      this.$emit('selection-changed', selectedRow.ID);
    },
    onAddClick() {
      this.isModalVisible = true;
    },
    onSave() {
      if (!this.formData.Denumire || this.formData.Denumire.trim() === '') {
        notify('Completați câmpul obligatoriu "Denumire"!', 'error', 1000);
        return;
      }
      if (!this.formData.IndustrieID || String(this.formData.IndustrieID).trim() === '') {
        notify('Completați câmpul obligatoriu "Industrie"!', 'error', 1000);
        return;
      }

      if (!this.formData.DataStart || this.formData.DataStart === null) {
        notify('Completați câmpul obligatoriu "Ziua de început"!', 'error', 1000);
        return;
      }
      if (!this.formData.DataEnd || this.formData.DataEnd === null) {
        notify('Completați câmpul obligatoriu "Ziua de final"!', 'error', 1000);
        return;
      }
      if (!this.formData.Buget || this.formData.Buget.trim() === '') {
        notify('Completați câmpul obligatoriu "Buget"!', 'error', 1000);
        return;
      }

      const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
      console.log(this.formData);
      const body = this.formData;
      CrmCampaniiMarketing.save(body).then((response) => {
        this.isModalVisible = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);
        this.formData = {
          Denumire: '',
          IndustrieID: '',
          DataStart: null,
          DataEnd: null,
          Buget: '',
          CurentActiv: false,
          Explicatie: ''
        };
        this.$refs.dataGridRef.instance.refresh();
      }).catch((error) => {
        console.error(error);
        notify('Datele există deja!', 'error', 1000);
      });
    },
    onCancel() {
      this.isModalVisible = false;
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGridRef?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
    onClick() {
      this.isModalVisible = true;
    },
    onColumnChooserClick() {
      const dataGrid = this.$refs.dataGrid.instance;
      dataGrid.showColumnChooser();
    },
    onRefreshClick() {
      this.$refs.dataGridRef.instance.refresh();
      notify('Datele au fost actualizate cu succes!', 'success', 1000);
    },
    onSaveEdit() {
      const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
      this.dataGridRef?.instance?.saveEditData();
      savePromise.then((result) => {

      }).catch((error) => {
        console.error(error);


      });
    },
    onCancelEdit() {
      this.dataGridRef?.instance?.cancelEditData();
    },
    onRowRemoving(e: any) {
      e.cancel = new Promise((resolve) => {
        this.dataGridRef?.instance?.saveEditData();
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        resolve(false);
      });
    },
  },
  mounted() {
    this.getIndustrii();
    this.createODataContext();
    this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });

    locale('ro');
  },
});
</script>
<style scoped>
.border {
  border-radius: 8px;
}

@import '../../../assets/dx.material.material-orange-light-compact.css'
</style>